import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.INYARWANDA_STORAGE_API,
  headers: {
    Accepted: "appication/json",
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
